// extracted by mini-css-extract-plugin
export default {"staffMore":"MoreButton_staffMore__r5c46"};